import { Component } from '@angular/core';
import { WelcomeCard } from '../../shared/models/card.type';
import { welcomeSubscribedCards } from '../../shared/information-cards';

@Component({
  selector: 'app-subscribed-user',
  templateUrl: './subscribed-user.component.html',
  styleUrls: ['./subscribed-user.component.scss']
})
export class SubscribedUserComponent {
  cards: WelcomeCard[] = welcomeSubscribedCards;

  currentRoute = '/subscribed-user';
}
